export const loginInitializer = (loginService, $rootScope) => {
	'ngInject';
	return {
	  restrict: 'A',
	  priority: 1000, // to ensure that the postLink run last.
	  link: function postLink(scope, element, attrs) {
		window.ipEventBus.subscribe('open-login-form', (channel, e) => {
		  	loginService.openLoginForm(e);
		}, true);
		window.ipEventBus.subscribe('logout', () => {
			$rootScope.userInfo = window.userInfo;
		  	loginService.logout();
		}, true);
	  }
	}
  };
